"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const offCountTypes = Object.freeze({
    VACATION: 'vacation',
    PTO: 'pto'
});
exports.default = offCountTypes;
